import { render, staticRenderFns } from "./FastActivationSidebarBadge.vue?vue&type=template&id=329f1130"
import script from "./FastActivationSidebarBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./FastActivationSidebarBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FastActivationSidebarBadge.vue?vue&type=style&index=0&id=329f1130&prod&module=styles&lang=scss"




function injectStyles (context) {
  
  this["styles"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports